import {
  KPI_OPTIMAL_BADGE_COLOR,
  KPI_CRITICAL_BADGE_COLOR,
  KPI_CAUTION_BADGE_COLOR,
} from '../../../../themes/tokens';
import { ChartData, MultipleSalonsChartData, SalonsByKpi } from './types';

export const getMultipleSalonsChartData = (data: SalonsByKpi): Array<any> => {
  if (!data || Object.keys(data).length === 0) {
    return [];
  }

  const chartData: Array<MultipleSalonsChartData> = data.salons.map((salon) => {
    return {
      field: salon.title,
      value: salon.value.normalized.value,
      rawValue: salon.value.raw.value,
      prefix: salon.value.raw.prefix || '',
      suffix: salon.value.raw.suffix || '',
      benchmarkMin: data.benchmark.raw.min,
      benchmarkMax: data.benchmark.raw.max,
    };
  });

  chartData.sort((a, b) => b.value - a.value);

  return chartData;
};

export const getBarColor = (item: ChartData) => {
  if (typeof item.rawValue === 'number') {
    if (item.benchmarkMax && item.rawValue > item.benchmarkMax) return KPI_OPTIMAL_BADGE_COLOR;
    if (item.benchmarkMin && item.rawValue < item.benchmarkMin) return KPI_CRITICAL_BADGE_COLOR;
    return KPI_CAUTION_BADGE_COLOR;
  } else {
    return KPI_CAUTION_BADGE_COLOR;
  }
};
